import React, { useState } from "react";
import "../../../../../ApiCalls/mantisFlowsManangment";
import "../../../../components/ui/button";
import { useToast } from "../../../../components/ui/use-toast";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../../../components/ui/table";
import "../../../../components/ui/badge";
import "../../components/CommentsSection";
import "../../Utils/utils";

export const DeliveryReconciliationSection = ({
  data,
  addLog,
  selectedSupplierId,
  onSupplierSelect,
  quotationItems = [],
  isLoadingQuotationItems,
  onStepChange,
  purchaseOrders,
}) => {
  useState(null);
  useState(null);
  useState(true);
  useToast();
  const [expandedPO, setExpandedPO] = useState(null);

  // FIX: Move this here
  const [receivedMap, setReceivedMap] = useState({});
  const handleReceivedChange = (itemId) => {
    setReceivedMap((prev) => ({
      ...prev,
      [itemId]: !prev[itemId],
    }));
  };

  
  // Función para renderizar el contenido de PO Creation
  const renderPOCreatedContent = () => {
    // Flatten all items from all POs, adding PO info to each item
    const allItems = purchaseOrders.flatMap((po) =>
      (po.items || []).map((item) => ({
        ...item,
        po_number: po.po_number || po.id,
        supplier_name: po.supplier_name,
        status: po.status,
        created_at: po.created_at,
        currency: po.currency,
        total_amount: po.total_amount,
      }))
    );

    return (
      <div className="p-3 overflow-auto h-full">
        <div className="bg-white dark:bg-slate-800 rounded border border-slate-200 dark:border-slate-700 shadow-sm">
          <div className="p-3 border-b border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/80">
            <h3 className="text-lg font-semibold text-slate-800 dark:text-slate-200 flex items-center">
              Purchase Order Items
            </h3>
          </div>
          <div className="overflow-x-auto">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>PO Number</TableHead>
                  <TableHead>Supplier</TableHead>
                  <TableHead>Status</TableHead>
                  <TableHead>Created At</TableHead>
                  <TableHead>Name</TableHead>
                  <TableHead>Delivery Time (days)</TableHead>
                  <TableHead>Quantity</TableHead>
                  <TableHead>Unit</TableHead>
                  <TableHead>Unit Price</TableHead>
                  <TableHead>Total Price</TableHead>
                  <TableHead>Received</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {allItems.map((item, idx) => (
                  <TableRow key={item.id || idx}>
                    <TableCell>{item.po_number}</TableCell>
                    <TableCell>{item.supplier_name}</TableCell>
                    <TableCell>{item.status}</TableCell>
                    <TableCell>{item.created_at?.slice(0, 10)}</TableCell>
                    <TableCell>{item.name}</TableCell>
                    <TableCell>{item.delivery_time_days}</TableCell>
                    <TableCell>{item.quantity}</TableCell>
                    <TableCell>{item.unit}</TableCell>
                    <TableCell>
                      {item.currency}{" "}
                      {Number(item.unit_price).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                      })}
                    </TableCell>
                    <TableCell>
                      {item.currency}{" "}
                      {Number(item.total_price).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                      })}
                    </TableCell>
                    <TableCell>
                      <input
                        type="checkbox"
                        checked={!!receivedMap[item.id]}
                        onChange={() => handleReceivedChange(item.id)}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </div>
      </div>
    );
  };

  return <div>{renderPOCreatedContent()}</div>;
};

export default DeliveryReconciliationSection;
